import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CommonImportResponse } from "helpers/data/CommonImport";
import { ProductsApi } from "apis/ProductsApi";
import { ProductsSearchFilterQuery } from "models/filters/products/ProductsSearchFilterQuery";
import { ManagedStocksApi, ProductImportModel } from "apis/ManagedStocksApi";
import { Product } from "models/dbModels/products/Product";

export function GetProductsById(productIds: number[]): Promise<CommonImportResponse<any>> {
    let functionResponse: CommonImportResponse<any> = {
        errors: [],
        data: []
    }

    return ProductsApi.Search({ ids: productIds })
    .then(result => {
        functionResponse.data = result.data.data;
        return functionResponse;
    }).catch((error) => {
        functionResponse.errors = [error];
        return functionResponse;
    });
}

export const getProducts = createAsyncThunk("productsSlice/getProducts", async (params: ProductsSearchFilterQuery) => {
    params = { ...params, loadPdes: params.loadPdes ?? false, loadApns: params.loadApns ?? false, contains: params.contains ?? true,
        searchPdes: params.searchPdes, searchBarcodes: params.searchBarcodes
    }
    const response = await ProductsApi.Search(params);
    return response.data;
});

export const importFromProducts = createAsyncThunk("productsSlice/importFromProducts", async (params: ProductImportModel) => {
    const response = await ManagedStocksApi.ImportFromProducts(params);
    return response.data;
});

const filter = {
    ethicalFilter: 0,
    scheduleFilter: "0",
    pbsFilter: 0,
    systemCodeFilter: "0",
    supplierCodesFilter: "",
    createDateBeforeFilter: "",
    createDateAfterFilter: "",
    managedStock: "",
}

type InitialStateType = {
    loading: boolean;
    keyword: string;
    searchPdes: boolean;
    searchBarcodes: boolean;
    totalRows: number;
    totalPages: number;
    pageIndex: number;
    pageSize: number;
    selectedRows: { position: number, id: number }[][];
    deselectedRows: { position: number, id: number }[][];
    selectAllFilter: boolean;
    error: string;
    table: Product[];
};

const initialState: InitialStateType = {
    loading: true,
    keyword: "",
    searchPdes: false,
    searchBarcodes: false,
    totalRows: 0,
    totalPages: 0,
    pageIndex: 0,
    pageSize: 100,
    selectedRows: [],
    deselectedRows: [],
    selectAllFilter: false,
    error: "",
    table: []
};

const productsSlice = createSlice({
    name: "productsSlice",
    initialState: {
        ...initialState,
        ...filter,
    },
    reducers: {
        setKeyword: (state, action) => {
            return {
                ...state,
                keyword: action.payload,
            };
        },
        addSelectedRows: (state, action) => {
            // @ts-ignore
            state.selectedRows[action.payload.index] = action.payload.rows;
        },
        addDeselectedRows: (state, action) => {
            // @ts-ignore
            state.deselectedRows[action.payload.index] = action.payload.rows;
        },
        addAGGridSelectedRows: (state, action) => {
            return {
                ...state,
                selectedRows: action.payload
            };
        },
        addAGGrideDeselectedRows: (state, action) => {
            return {
                ...state,
                deselectedRows: action.payload
            };
        },
        updateProductField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value
            };
        },
        clearFilters: (state) => {
            return {
                ...state,
                ...filter,
            };
        },
        clearSystemStocksState: (state) => {
            return {
                ...state,
                ...initialState,
                totalRows: state.totalRows
            };
        },
    }, extraReducers: (builder) => {
        builder.addCase(getProducts.pending, (state) => {
            return {
                ...state,
                loading: true,
                table: [],
                error: "",
            };
        });
        builder.addCase(getProducts.fulfilled, (state, action) => {
            state.loading = false;
            state.table = action.payload.data ? action.payload.data : [];
            state.totalRows = action.payload.totalRows;
            state.totalPages = Math.ceil(Math.ceil(action.payload.totalRows) / state.pageSize);
        });
        builder.addCase(getProducts.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || "";
        });
    }
});

export const { clearSystemStocksState, clearFilters, setKeyword, addSelectedRows,
    updateProductField, addDeselectedRows, addAGGridSelectedRows, addAGGrideDeselectedRows } = productsSlice.actions;

export default productsSlice.reducer;